import { defineComponent as _defineComponent } from 'vue'
import { userConfig } from '@/store';
import { useI18n } from 'vue-i18n';
import { set_theme, themes } from '@/style/theme';
import theme from '@/store/theme';
import languages from '@/store/language';
import { pageSizeConfig } from '@/store';
import { ref } from 'vue';
import userApi from '@/api/account'
import { Cookies } from '@/utils';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();
const { locale } = useI18n();

const form = ref({ removeFirst: 0, range1: 30 });

// 排序方式
const sortOrder = ['id', 'idDesc', 'name', 'nameDesc', 'time', 'timeDesc'];

function language_change(val: string) {
	locale.value = val;
	localStorage.setItem('language', val);
}

function theme_change(val: string) {
	set_theme(val);
	localStorage.setItem('theme', val);
}

function theme_color(theme: string) {
	// @ts-ignore
	const color = themes[theme]['s-back'];
	return {
		backgroundColor: color,
	};
}

function switch_change(val: string) {

}

function sort_order_change(val: string) { }

function submit() {
	const userName = Cookies.get('userName');
	const configValue = JSON.stringify({ userConfig, pageSizeConfig });

	userApi.set_user_config(userName, configValue);

}

function user_logout() {
	Cookies.remove('userName');
	Cookies.remove('userId');
	router.push('/login')
}

const __returned__ = { router, locale, form, sortOrder, language_change, theme_change, theme_color, switch_change, sort_order_change, submit, user_logout, get userConfig() { return userConfig }, get theme() { return theme }, get languages() { return languages } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})